module.exports = __webpack_public_path__ + "static/media/flag-spain.1c6f3621.svg";